import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ResponsabileLayout } from "./ResponsabileLayout";
import { Loader2, ChevronRight } from "lucide-react";

const eur = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;
const STATO_ORD = { programmata: ["Programmata", "text-slate-300"], aperta: ["Aperta", "text-emerald-300"], chiusa: ["Chiusa", "text-red-300"] };
const STATO_PROD = { raccolta_ordini: "Raccolta ordini", ordini_chiusi: "Ordini chiusi", in_preparazione: "In preparazione", in_produzione: "In produzione", pronto: "Pronto", consegnato: "Consegnato" };

export default function PortaleRaccolte() {
  const navigate = useNavigate();
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/raccolta/portale/raccolte").then(({ data }) => setLista(data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <ResponsabileLayout>
      <h1 className="text-2xl font-bold text-slate-100 mb-4">Le mie raccolte</h1>
      {loading ? (
        <div className="flex items-center gap-2 text-slate-400"><Loader2 className="w-5 h-5 animate-spin" /> Caricamento...</div>
      ) : lista.length === 0 ? (
        <p data-testid="portale-empty" className="text-slate-500 text-sm">Nessuna raccolta assegnata al momento.</p>
      ) : (
        <div className="space-y-3" data-testid="portale-raccolte-list">
          {lista.map((r) => {
            const [sl, sc] = STATO_ORD[r.stato_ordini] || STATO_ORD.programmata;
            return (
              <button key={r.id} data-testid={`portale-raccolta-${r.id}`} onClick={() => navigate(`/responsabile/raccolte/${r.id}`)} className="w-full text-left glass rounded-2xl p-4 hover:border-amber-400/40 border border-transparent transition-all">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-lg font-bold text-slate-100">{r.nome_gruppo}</div>
                    <div className="text-xs text-slate-500">{r.tipologia_gruppo} · {r.festa} · {r.edizione}</div>
                  </div>
                  <ChevronRight className="w-5 h-5 text-slate-500" />
                </div>
                <div className="flex items-center gap-3 mt-2 text-sm">
                  <span className={sc}>● {sl}</span>
                  <span className="text-slate-500">Produzione: {STATO_PROD[r.stato_produzione]}</span>
                </div>
                <div className="grid grid-cols-3 gap-2 mt-3 text-center">
                  <div><div className="font-bold text-slate-200">{r.num_ordini}</div><div className="text-[10px] uppercase text-slate-500">Ordini</div></div>
                  <div><div className="font-bold text-cyan-300">{eur(r.incassato)}</div><div className="text-[10px] uppercase text-slate-500">Incassato</div></div>
                  <div><div className="font-bold text-amber-300">{eur(r.saldo_da_consegnare)}</div><div className="text-[10px] uppercase text-slate-500">Saldo</div></div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </ResponsabileLayout>
  );
}
